import React from 'react';
import * as Fi from 'react-icons/fi';
import { Button, Modal } from 'react-bootstrap';
import { currencyFormat } from 'utilities/common';
import { FormAdditional } from '../form/form.additional';
import { useDispatch, useSelector } from 'react-redux';
import { Manifest } from 'services/action';

export const SectionAdditional = ({
  data,
  onSubmit,
}) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state.Form);

  const [additionals, setAdditionals] = React.useState(null);
  const [temp, setTemp] = React.useState(null);
  const [showUpdate, setShowUpdate] = React.useState(false);
  const [showDelete, setShowDelete] = React.useState(false);

  const $onLoad = async(id) => {
    const req = await Dispatch(Manifest.$getAdditional(id))
    if (req?.message === 'success') {
      setAdditionals(req?.data)
    }
  }

  const $handleUpdate = async (d, i) => {
    setTemp(d);
    setShowUpdate(!showUpdate);
  };

  const emitUpdate = () => {
    setTemp(null);
    setShowUpdate(false);
    onSubmit();
  };

  const $handleDelete = async (val) => {
    setShowDelete(true);
    setTemp(val);
  };

  const $emitDelete = async () => {
    const req = await Dispatch(Manifest.$deleteAdditional(temp?.id));
    if (req?.message === 'success') {
      onSubmit();
      setTemp(null);
      setShowDelete(false);
    }
  };

  React.useEffect(() => {
    if (!data) return

    $onLoad(data?.id);
  }, [data])

  if (!additionals) return null;

  return (
    <div className="p-0 p-md-3 pe-md-0 mb-3 mb-md-0">
      <div className="card rounded-2 bg-white">
        <div className="card-header-gray p-3 border-bottom">
          <h3 className="card-title dx-card-title m-0 p-0">Biaya Tambahan</h3>
        </div>
        <div className="card-body p-3 pt-3">
          <div className="row datagrid-item">
            <div
              className={`col-${
                data?.status === 'completed' ? '6' : '4'
              } datagrid-title`}
            >
              Keterangan
            </div>
            <div
              className={`col-${
                data?.status === 'completed' ? '6' : '4'
              } datagrid-title text-end`}
            >
              Nominal
            </div>
            {data?.status !== 'completed' && (
              <div className="col-4 datagrid-title"></div>
            )}
          </div>
          {additionals?.map((d, i) => (
            <div
              className="row justify-content-center align-items-center border-bottom py-2"
              key={i}
            >
              <div
                className={`col-${
                  data?.status === 'completed' ? '6' : '4'
                } datagrid-content text-uppercase fs-8`}
              >
                {d?.description}
              </div>
              <div
                className={`col-${
                  data?.status === 'completed' ? '6' : '4'
                } datagrid-content text-uppercase fs-8 text-end`}
              >
                {currencyFormat(d?.nominal, 'IDR')}
              </div>
              {data?.status !== 'completed' && (
                <div className="col-4 datagrid-title">
                  <div
                    className="btn-toolbar justify-content-end"
                    role="toolbar"
                  >
                    <button
                      type="button"
                      className="btn btn-danger btn-xs me-1"
                      onClick={() => $handleDelete(d)}
                    >
                      hapus
                    </button>
                    <button
                      type="button"
                      className="btn btn-xs"
                      onClick={() => $handleUpdate(d)}
                    >
                      Edit
                    </button>
                  </div>
                </div>
              )}
            </div>
          ))}

          <div className="row datagrid-item py-2 bg-primary-lt mt-3">
            <div
              className={`col-${
                data?.status === 'completed' ? '6' : '4'
              } text-secondary`}
            >
              Total
            </div>
            <div
              className={`col-${
                data?.status === 'completed' ? '6' : '4'
              } text-end fw-bold text-secondary`}
            >
              {currencyFormat(data?.total_additional, 'IDR')}
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showUpdate}
        onHide={() => setShowUpdate(false)}
        backdrop="static"
        centered
        size="small"
      >
        <Modal.Header closeButton>
          <Modal.Title>Perbaharui Biaya Tambahan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <FormAdditional data={temp} onSubmit={emitUpdate} />
        </Modal.Body>
      </Modal>

      {/* modal delete */}
      <Modal
        show={showDelete}
        onHide={() => setShowDelete(false)}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={() => setShowDelete(false)} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={() => setShowDelete(false)}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
                onClick={$emitDelete}
                disabled={StateForm?.loading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
